module.exports = __webpack_public_path__ + "img/ic24Contract.4932cfe0.svg";